import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from } from 'rxjs';
import { UserRoles } from 'src/app/auth/auth.model';

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
})
export class NotFoundPageComponent implements OnInit {
  userRoles = UserRoles;

  isAuth: boolean = false;

  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    private keycloakSrv: KeycloakService
  ) {}

  ngOnInit(): void {
    this.setUserAuth();
  }

  get role(): string {
    if (this.keycloakSrv.isUserInRole(this.userRoles.CPI.toString())) {
      return 'cpi';
    } else if (this.keycloakSrv.isUserInRole(this.userRoles.ENTE.toString())) {
      return 'ente';
    } else if (
      this.keycloakSrv.isUserInRole(this.userRoles.REGIONE.toString())
    ) {
      return 'regione';
    }
    return 'cittadino';
  }

  setUserAuth() {
    from(this.keycloakSrv.isLoggedIn()).subscribe((auth) => {
      this.isAuth = auth;
    });
  }
}
